module.exports = __webpack_public_path__ + "static/color element-19-d5239995106baa774335dbf29db94181.png";